import http from "../../services/http";
import { getClientById, updateClientWithCompany } from "../client/client.actions";
import { companyActionTypes } from "./company.types";

export const selectCurrentCompany = state => state.company.currentCompany;
export const selectCompanyValidated = state => state.company.companyValidated;

export const setCompany = (company) => ({
  type: companyActionTypes.SET_COMPANY,
  payload: company
});

export const setCompanyValidated = (company) => ({
  type: companyActionTypes.SET_COMPANY_VALIDATED,
  payload: company
});

export const postCompany = (company) => {
  return async dispatch => {
    try {
      const response = await http.post(`/companies`, { ...company, status: 1 });
      dispatch(setCompany(response.data));
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };
};

export const getCompany = (query, client) => {
  const queryString = Object.entries(query)
    .filter(([, value]) => value !== undefined)
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join('&');

  return async (dispatch) => {
    try {
      const response = await http.get(`/companies?${queryString}`);
      if (response.data.length === 0) {
        const res = await dispatch(postCompany(query));
        dispatch(setCompany(res));
        dispatch(updateClientWithCompany(client, res.id));
        return response.data;
      } else {
        dispatch(setCompany(response.data[0]));
        return response.data;
      }
    } catch (error) {
      console.log(error);
      throw error;
    }
  };
};

export const updateCompany = (company, code) => {
  return async (dispatch, getState) => {
    const currentClient = getState().clients.currentClient;

    try {
      const updateResponse = await http.put(`/companies/${company.id}`, { ...company, code: code });
      dispatch(getClientById(currentClient.id));
      dispatch(setCompany(updateResponse.data));
      dispatch(setCompanyValidated(true));
    } catch (error) {
      console.log(error);
    }
  };
};